import { combineReducers } from 'redux';
import Cookies from 'js-cookie';
import * as types from './types';

const sortOnlineFirstCookie = Cookies.get('SortOnlineFirst');

const initialState = {
  status: { id: '', displayName: '' },
  operationType: { id: '', displayName: '' },
  publicationPlan: { id: '', displayName: '' },
  publicationPlanId: { id: '', displayName: '' },
  realEstateType: { id: '', displayName: '' },
  searchCode: { id: '', displayName: '' },
  province: { id: '', displayName: '' },
  city: { id: '', displayName: '' },
  zone: { id: '', displayName: '' },
  sort: { id: 'modifiedNewer', displayName: 'modifiedNewer' },
  hasDuplicates: { id: '', displayName: '' },
  branches: { id: '', displayName: '' },
  publishedBy: { id: '', displayName: '' },
  hasQuality: { id: '', displayName: '' },
  hasReports: { id: '', displayName: '' },
  hasReportsTotal: { id: '', displayName: '' },
  onlineFirst: sortOnlineFirstCookie || true
};

const appliedFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_APPLIED_FILTERS:
      return { ...state, ...action.payload.filters };
    case types.RESET_FILTERS:
      return { ...state, ...initialState };
    case types.PARTIAL_RESET_FILTERS:
      return { ...state, ...initialState, [action.payload.filterName]: action.payload.filterValue };
    default:
      return state;
  }
};

const filtersOrderReducer = (state = [], action) => {
  switch (action.type) {
    case types.MODIFY_SELECTED_FILTER: {
      const filterArr = Object.entries(action.payload.filter);
      let result = state;
      for (let i = 0; i < filterArr.length; i += 1) {
        const [key, value] = filterArr[i];
        if (value) {
          result = [...result.filter(item => item !== key), key];
        }
        if (!value) {
          result = [...result.filter(item => item !== key)];
        }
      }
      return result;
    }
    default:
      return state;
  }
};

const filterModalReducer = (state = false, action) => {
  switch (action.type) {
    case types.TOGGLE_FILTERS_MODAL:
      return !state;
    default:
      return state;
  }
};

const filtersReducer = combineReducers({
  filtersModalVisibility: filterModalReducer,
  filtersOrder: filtersOrderReducer,
  appliedFilters: appliedFiltersReducer
});

export default filtersReducer;
